import React from 'react';
import ReactDOM from 'react-dom/client';
import './sentry'; // Init suivi d'erreurs (le plus tôt possible)
import "leaflet/dist/leaflet.css";
// Polices embarquées (offline, sans CDN) : Inter (corps) + Quicksand (titres)
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/quicksand/500.css";
import "@fontsource/quicksand/600.css";
import "@fontsource/quicksand/700.css";
import './index.css';
import './i18n'; // Initialise i18n
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
